// Proje Detay eylem paneli kopya TEK kaynağı (Finar UX P2 Ö2/İ6). Satır içi string yazılmaz.
// e2e spec 18'deki COPY bloğu elle eşlenik kopyadır — birini değiştirince diğerini de güncelle.
export const PROJECT_ACTIONS_COPY = {
  continueForm: "Forma Devam Et",
  startGeneration: "AI Üretimi Başlat",
  review: "Bölümleri Gözden Geçir",
  more: "Diğer ⋯",
  moreAria: "Diğer eylemler",
  secondaryGroup: "Diğer proje eylemleri",
  regenerateAll: (nextVersion: number): string =>
    `Tümünü Yeniden Üret (v${nextVersion.toString()})`,
  regenerateAllTitle: (current: number): string =>
    `v${current.toString()} korunur; v${(current + 1).toString()} üretilir`,
  archive: "Arşive Al",
  archiveTitle: "Onay durumuna bakmadan projeyi tamamlandı/arşivde işaretle",
  archiveConfirmTitle: "Proje arşive alınsın mı?",
  archiveConfirmBody:
    "Proje “Tamamlandı” olarak işaretlenip arşive taşınır. Bölüm onay durumlarına bakılmaz; form ve üretim kilitlenir. Gerekirse “Projeyi Tekrar Aç” ile geri açılabilir.",
  archiveConfirmAction: "Arşive Al",
  archiveFailed: "Proje arşive alınamadı",
  finalDownload: "Final Raporu İndir (DOCX)",
  finalDownloadTitle: "Onaylanmış AI içerikleriyle nihai Word (.docx) raporu",
  finalDownloadFailed: "Final rapor indirilemedi",
  complete: "✓ Projeyi Tamamla",
  completeTitle: "Projeyi 'Tamamlandı' olarak işaretle (arşive geçer)",
  completeFailed: "Proje tamamlanamadı",
  reopen: "Projeyi Tekrar Aç",
  reopenTitle: "Proje tamamlanmış. Admin olarak tekrar düzenlemeye açabilirsiniz (cascade reopen).",
  reopenPrompt:
    "Projeyi tekrar açma nedeni (en az 5 karakter):\n\n" +
    "• Onaylanmış tüm bölümlerin onayı kaldırılır.\n" +
    "• Atanan danışman ve siz tekrar düzenleme yapabilirsiniz.\n" +
    "• Mevcut DOCX rapor arşivlenir, yeni rapor üretmek gerekir.\n" +
    "• Bu işlem audit log'a kaydedilir.",
  reopenTooShort: "Neden en az 5 karakter olmalı.",
  reopenFailed: "Proje tekrar açılamadı",
  busy: "İşleniyor…",
  preparing: "Hazırlanıyor…",
  reopening: "Açılıyor…",
  importActive: "Aktarım sürüyor",
} as const;
